import { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Sidebar from './Sidebar.jsx'
import TopBar from './TopBar.jsx'
import MaturityContext from './MaturityContext.jsx'
import { workspaceForPath } from '../../config/workspaceConfig.js'

const STORAGE_KEY = 'bfa-sidebar-collapsed'

export default function AppShell({ session, member, onSignOut }) {
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem(STORAGE_KEY) === 'true')
  const [mobileOpen, setMobileOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(() => window.matchMedia('(max-width: 900px)').matches)
  const location = useLocation()
  const currentWorkspace = workspaceForPath(location.pathname)

  useEffect(() => { localStorage.setItem(STORAGE_KEY, String(collapsed)) }, [collapsed])
  useEffect(() => { setMobileOpen(false) }, [location.pathname])
  useEffect(() => {
    const media = window.matchMedia('(max-width: 900px)')
    const update = () => setIsMobile(media.matches)
    media.addEventListener('change', update)
    return () => media.removeEventListener('change', update)
  }, [])
  useEffect(() => {
    if (!mobileOpen) return undefined
    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    const close = (event) => {
      if (event.key === 'Escape') {
        setMobileOpen(false)
        requestAnimationFrame(() => document.querySelector('.mobile-menu-button')?.focus())
      }
    }
    document.addEventListener('keydown', close)
    return () => {
      document.body.style.overflow = previousOverflow
      document.removeEventListener('keydown', close)
    }
  }, [mobileOpen])

  return (
    <div className={`app-shell ${collapsed ? 'shell-collapsed' : ''}`}>
      <a className="skip-link" href="#main-content">Skip to content</a>
      <Sidebar collapsed={collapsed} mobileOpen={mobileOpen} isMobile={isMobile} onNavigate={() => setMobileOpen(false)} onClose={() => { setMobileOpen(false); requestAnimationFrame(() => document.querySelector('.mobile-menu-button')?.focus()) }} />
      <div className="workspace" inert={mobileOpen ? true : undefined}>
        <TopBar session={session} member={member} currentWorkspace={currentWorkspace} collapsed={collapsed} onToggleCollapsed={() => setCollapsed((value) => !value)} onOpenMobile={() => setMobileOpen(true)} onSignOut={onSignOut} />
        <MaturityContext />
        <main className="main-content" id="main-content" tabIndex="-1"><div className="content-container"><Outlet context={{ session, member }} /></div></main>
      </div>
    </div>
  )
}
